<template>
  <div id="PageEcovadis">
    <SectionHero />
    <SectionTrust />
    <SectionEcovadisReviews />
    <SectionEcovadisPartners class="PageEcovadis__sectionEcovadisPartners" />
    <SectionEcovadisTargetRating />
    <SectionFastTrackProcess />
    <SectionEcovadisTrackRecord />
    <SectionEcovadisDifference />
    <SectionEcovadisFAQ />
    <SectionBookScopingCall />
  </div>
</template>

<script setup lang="ts">
import SectionEcovadisPartners from '@/views/components/sections/SectionEcovadisPartners.vue'
import SectionHero from './sections/SectionHero.vue'
import SectionEcovadisTargetRating from '@/views/components/sections/SectionEcovadisTargetRating.vue'
import SectionEcovadisFAQ from '@/views/components/sections/SectionEcovadisFAQ.vue'
import SectionEcovadisTrackRecord from '@/views/components/sections/SectionEcovadisTrackRecord.vue'
import SectionTrust from '@/views/components/sections/SectionTrust.vue'
import SectionEcovadisReviews from './sections/SectionEcovadisReviews.vue'
import SectionBookScopingCall from './sections/SectionBookScopingCall.vue'
import SectionFastTrackProcess from './sections/SectionFastTrackProcess.vue'
import SectionEcovadisDifference from './sections/SectionEcovadisDifference.vue'
import { useSeo, getBreadcrumbStructuredData } from '@/composables/useSeo'
import { getSeoConfig } from '@/config/seo'

// SEO Configuration
useSeo(
  getSeoConfig('ecovadis'),
  getBreadcrumbStructuredData([
    { name: 'Home', url: 'https://sustainalyse.com/' },
    { name: 'EcoVadis Assessment Help', url: 'https://sustainalyse.com/ecovadis' }
  ])
)
</script>

<style lang="scss" scoped>
#PageEcovadis {
  min-height: 100vh;
}
</style>
